import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
import InventoryQuantity from '@square/dashboard-items-data/models/squareup/inventory/v3/inventory-quantity';
import InventoryState from '@square/dashboard-items-data/models/squareup/inventory/v3/inventory-state';
import ProductIdentifier from '@square/dashboard-items-data/models/squareup/inventory/v3/product-identifier';
const AdjustmentGroup = ProtoBaseModel.extend({
  rootAdjustmentToken: attr(String)
});
export default ProtoBaseModel.extend({
  adjustmentGroup: attr(AdjustmentGroup),
  token: attr(String),
  productIdentifier: attr(ProductIdentifier),
  fromState: attr(InventoryState),
  toState: attr(InventoryState),
  quantity: attr(InventoryQuantity),
  quantityDecimal: attr(String),
  occurredAt: attr(Number),
  adjustedBy: attr(String),
  cost: attr(MoneyProto),
  unitCost: attr(MoneyProto, {
    key: 'read_only_unit_cost'
  }),
  totalCost: attr(MoneyProto),
  totalSalesPrice: attr(MoneyProto),
  // associated events - oneof
  billToken: attr(String),
  refundToken: attr(String),
  purchaseOrderToken: attr(String),
  transferOrderToken: attr(String),
  salesOrderId: attr(String),
  legacyBulkImportId: attr(String),
  connectOauthClientId: attr(String),
  bulkAdjustToken: attr(String),
  linkedReturnBillToken: attr(String),
  // allows adjustments that result in negative quantities
  forced: attr(Boolean, {
    defaultValue: true
  })
});